/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} State_Feeds_Error_UpdateInputs */

const en_state_feeds_error_update = /** @type {(inputs: State_Feeds_Error_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update feeds`)
};

/**
* | output |
* | --- |
* | "Failed to update feeds" |
*
* @param {State_Feeds_Error_UpdateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const state_feeds_error_update = /** @type {((inputs?: State_Feeds_Error_UpdateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<State_Feeds_Error_UpdateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_state_feeds_error_update(inputs)
});
export { state_feeds_error_update as "state.feeds.error.update" }